<template>
  <div class="template">
    <h2 style="margin: 20px 0;">{{ this.$route.query.serviceName }}</h2>
    <el-button style="margin: 20px 0;" type="primary" @click="save()">保存</el-button>
    <div v-for="(page,index) in list" class="page">
      <el-card>
        <el-button type="danger" @click="delPage(index)">删除该页面</el-button>
        <div slot="header" class="clearfix">
          <span>第{{index+1}}个页面</span>
        </div>

        <el-row :gutter="20">
          <el-col :span="12">
            <h3>编辑</h3>
            <el-form :inline="true">
              <el-form-item>
                <el-select v-model="type[index]" placeholder="请选择" style="width: 150px">
                  <el-option label="标题" value="text"></el-option>
                  <el-option label="文本组件" value="input"></el-option>
                  <el-option label="选择组件" value="select"></el-option>
                  <el-option label="时间组件" value="time"></el-option>
                  <el-option label="位置组件" value="location"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="type[index]==='text'">
                <el-input placeholder="请输入内容" v-model="content[index]" class="input-with-select"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-plus" @click="add(index)">添加新组件</el-button>
              </el-form-item>
            </el-form>

            <div v-for="(item,i) in page">
              <el-form label-position="top">
                <div v-if=" item.templateItemType=='text' ">
                  <h3>标题</h3>
                  <el-button @click="remove(index,i)">删除标题</el-button>
                  <el-form-item label="标题">
                    <el-input v-model="item.content"></el-input>
                  </el-form-item>
                </div>

                <div v-if=" item.templateItemType=='select' ">
                  <h3>选择组件</h3>
                  <el-button @click="remove(index,i)">删除选择组件</el-button>
                  <el-form-item label="是否多选">
                    <el-switch
                      v-model="item.isMultChoice"
                      :active-value="1"
                      :inactive-value="0"
                    />
                  </el-form-item>
                  <el-form-item label="是否必选">
                    <el-switch
                      v-model="item.isNessary"
                      :active-value="1"
                      :inactive-value="0"
                    />
                  </el-form-item>
                  <el-form-item label="选择组件(点击删除)">
                    <el-checkbox-group @click="removeOption(index,i,j)">
                      <span  v-for="(c,j) in item.content " @click="removeOption(index,i,j)">
                        <el-checkbox :label="c"></el-checkbox>&nbsp;&nbsp;
                      </span>
                      <el-button size="mini" icon="el-icon-plus" style="float: right;" type="text"
                        @click="addOption(index,i)">添加选项
                      </el-button>
                    </el-checkbox-group>
                  </el-form-item>
                </div>


                <div v-if=" item.templateItemType=='time' ">
                  <h3>日期组件</h3>
                  <el-button @click="remove(index,i)">删除日期组件</el-button>
                  <el-form-item label="是否必选">
                    <el-switch
                      v-model="item.isNessary"
                      :active-value="1"
                      :inactive-value="0"
                    />
                  </el-form-item>
                  <el-date-picker
                    type="datetime"
                    placeholder="选择日期时间"
                    align="right"
                  >
                  </el-date-picker>
                </div>

                <div v-if=" item.templateItemType=='location' ">
                  <h3>位置组件</h3>
                  <el-form-item>
                    <el-button @click="remove(index,i)">删除位置组件</el-button>
                  </el-form-item>
                  <el-form-item label="是否必选">
                    <el-switch
                      v-model="item.isNessary"
                      :active-value="1"
                      :inactive-value="0"
                    />
                  </el-form-item>
                  <el-form-item label="位置组件">
                  </el-form-item>
                </div>


                <div v-if=" item.templateItemType=='input' ">
                  <h3>文本组件</h3>
                  <el-form-item>
                    <el-button @click="remove(index,i)">删除文本组件</el-button>
                  </el-form-item>
                  <el-form-item label="是否必选">
                    <el-switch
                      v-model="item.isNessary"
                      :active-value="1"
                      :inactive-value="0"
                    />
                  </el-form-item>
                  <el-form-item label="文本组件">
                    <el-input placeholder="请输入文本" type="textarea"></el-input>
                  </el-form-item>

                </div>

              </el-form>
            </div>
          </el-col>
          <el-col :span="12">
            <h3>预览</h3>


            <div v-for="item in page">

              <el-form label-position="top">

                <div v-if=" item.templateItemType=='text' " l>
                  <el-form-item>
                    <p>{{item.content}}</p>

                  </el-form-item>
                </div>
                <div v-if=" item.templateItemType=='select' ">
                  <el-form-item>
                    <el-checkbox-group>
                      <el-checkbox v-for=" c,k in item.content " :label="c" :key="k"></el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </div>

                <div v-if=" item.templateItemType=='time' ">
                  <el-date-picker
                    type="datetime"
                    placeholder="选择日期时间"
                    align="right"
                  >
                  </el-date-picker>
                </div>

                <div v-if=" item.templateItemType=='location' ">
                  <el-form-item>
                    位置组件
                    <!--<el-input placeholder="输入位置"></el-input>-->
                  </el-form-item>

                </div>

                <div v-if=" item.templateItemType=='input' ">
                  <el-form-item>

                    <el-input type="textarea"></el-input>
                  </el-form-item>

                </div>
              </el-form>
            </div>
          </el-col>
        </el-row>


      </el-card>
      <br/>
    </div>

    <br/>

    <el-button type="primary" @click="addPage">添加页面</el-button>


  </div>
</template>

<script>
  import axios from '../request'

  const list = '/template/get'
  const update = '/template/replace'
  const post = '/template/replace'

  export default {
    name: 'template-list',
    data () {
      return {
        loading: true,
        search: '',
        list: [],
        content: [],
        type: [],
        exist: true,
      }
    },
    methods: {
      async fetch () {
        let id = this.$route.query.serviceId
        let res = await axios.get(list, {params: {serviceId: id}})

        this.list = res.data.data.pages
        this.exist = res.data.data.exist
      },
      exports () {

      },
      remove (index, i) {
        this.list[index].splice(i, 1)
      },
      removeOption (index, i, j) {
        this.list[index][i].content.splice(j, 1)
      },
      async addOption (index, i) {
        try {
          let {value} = await this.$prompt('输入选项名')
          if (Array.isArray(this.list[index][i].content)) {
            this.list[index][i].content.push(value)
          } else {
            this.list[index][i].content = [value]
          }
        } catch (e) {

        }
      },
      add (index) {
        if (this.list[index].length > 1) {
          this.$message.error('一个页面，只能有一个描述，一个操作组件')
          return
        }
        let content = this.content[index],
          id = this.$route.query.serviceId,
          obj = {
            isNessary: 0,
            instruction: '',
            serviceId: id,
            content: content,
            templateItemType: this.type[index],
            seq: this.list[index].length + 1,
            isMultChoice: 0,
          }
        if (this.type === 'select') {
          obj.content = [this.content[index]]
          obj.isMultChoice = 1
        }

        this.list[index].push(obj)
        this.content[index] = ''
      },
      async save () {
        let id = this.$route.query.serviceId

        let url
        if (this.exist) {
          url = update + '?serviceId=' + id
        } else {
          url = post + '?serviceId=' + id
        }

        let res = await axios.post(url, {
          pages: this.list,
        })

        let {code} = res.data
        if (code === 200) {
          this.$message.success('修改页面成功')
        }

      },
      addPage () {
        this.content.push()
        this.list.push([])
        this.type.push('text')
      },
      delPage (index) {
        this.content.splice(index, 1)
        this.list.splice(index, 1)
      },
    },
    mounted () {
      this.fetch()
    },
  }
</script>

<style>
  .template {

  }

</style>



// WEBPACK FOOTER //
// src/views/template/index.vue